import { Entity, EntityResolved } from '@api';
import { prependEntitiesDedupedByTag } from '../watchlist-manager-widget/utils';

export const buildRowSelectionFromTags = (
  tags: string[]
): Record<string, boolean> => Object.fromEntries(tags.map(tag => [tag, true]));

export const toEntityResolved = (entity: Entity): EntityResolved => ({
  ...entity,
  input: '',
});

export const tagsEqual = (a: string[], b: string[]) =>
  a.length === b.length && a.every((tag, index) => tag === b[index]);

export const mergeHydratedEntitiesIntoList = (
  prev: EntityResolved[],
  {
    hydrated,
    position = 'prepend',
  }: {
    hydrated: EntityResolved[];
    position?: 'prepend' | 'append';
  }
): EntityResolved[] => {
  const hydratedTagSet = new Set(hydrated.map(entity => entity.tag));
  const other = prev.filter(entity => !hydratedTagSet.has(entity.tag));

  if (position === 'append') {
    return [...other, ...hydrated];
  }

  return prependEntitiesDedupedByTag(hydrated, other);
};

// Tags leaving the filter that are not protected (manual chat/picker or edit prefill).
export const getRemovedFilterTagsNotProtected = (
  removedTags: readonly string[],
  protectedTags: ReadonlySet<string>
): string[] => removedTags.filter(tag => !protectedTags.has(tag));
